import {
  CcfBox,
  CcfDeboucedInput,
  CcfInteractionAcdIcon,
  CcfInteractionEmailIcon,
  CcfInteractionSearchChatIcon,
  CcfInteractionSearchColumnIcon,
  CcfInteractionSearchOutboundIcon,
  CcfOverflowIcon,
  CcfSupervisorFilterIcon,
  CcfTypography,
} from '@nice-ccf/ui-controls';
import styles from './ccf-interaction-search-messages-tab.module.scss';
import { makeStyles } from '@mui/styles';
import { DataGrid } from '@mui/x-data-grid';
import { useEffect, useState } from 'react';
import { interactionSearchData } from '../../ccf-interaction-search-cases-tab/ccf-interaction-search-cases-tab/ccf-interactionSearch-staticData';
import { fomatToDateString, fomatToTimeString } from '@nice-ccf/core-sdk';
import { Button, InputAdornment, useMediaQuery } from '@mui/material';
import { Theme, useTheme } from '@mui/material';

import { Search } from '@mui/icons-material';
import CcfInteractionSearchCasesFilters from '../../ccf-interaction-search-cases-tab/ccf-interaction-search-cases-tab/ccf-interaction-search-cases-filters';

/* eslint-disable-next-line */
export interface CcfInteractionSearchMessagesTabProps {}

const useStyles = makeStyles({
  root: {
    '& .MuiDataGrid-root': {
      border: '1px solid rgba(251, 252, 252, 1)',
      Height: '330px',
    },

    '& .MuiDataGrid-columnHeaderTitleContainer': {
      padding: '0px',
      fontFamily: 'Open Sans',
      fontStyle: 'normal',
      fontWeight: 600,
      fontSize: '12px',
      lineHeight: '16px',
      textTransform: 'uppercase',
      color: '#526B79',
    },
    '& .MuiDataGrid-columnsContainer': {
      background: '#FFFFF',
      border: '1px solid #D2D8DB',
      boxShadow: '0px 3px 4px rgba(0, 0, 0, 0.08)',
    },
    '& .styledrows': {
      height: '36px',
      background: '#FFFFF',
      border: '1px solid #D2D8DB',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      fontFamily: 'Open Sans',
      fontStyle: 'normal',
      fontWeight: '400',
      fontSize: '13px',
      lineHeight: '18px',

      color: '#333333',

      /* Inside auto layout */
    },
    // '& .MuiDataGrid-window': {
    //   height: '285px',
    //   overflowY: 'scroll',
    // },
  },
  searchInput: {
    '&.MuiOutlinedInput-inputAdornedEnd': {
      paddingBottom: '7.5px',
    },
  },
});

/**
 * Function to handle drawer open close
 * @example renderIconForType()
 */
const renderIconForType = (param: string) => {
  switch (param) {
    case 'email':
      return <CcfInteractionEmailIcon />;
    case 'inbound':
      return <CcfInteractionAcdIcon />;
    case 'outbound':
      return <CcfInteractionSearchOutboundIcon />;
    case 'chat':
      return <CcfInteractionSearchChatIcon />;
    default:
      return '';
  }
};

export const columns = [
  {
    field: 'caseId',
    headerName: 'caseId'.toUpperCase(),
    flex: 1,
    maxWidth: 190,
    sortable: false,
    hide: false,
  },
  {
    field: 'createdAt',
    headerName: 'created date'.toUpperCase(),
    flex: 1,
    maxWidth: 250,
    hide: false,
  },
  {
    field: 'status',
    headerName: 'read status'.toUpperCase(),
    flex: 1,
    maxWidth: 180,
    hide: false,
  },
  {
    field: 'channel',
    headerName: 'channel'.toUpperCase(),
    maxWidth: 180,
    flex: 1,
    headerClassName: 'gridHeaderText',
    renderCell: (params: any) => {
      const iconType =
        params.value === 'voice' && params.row.voiceDirection === 'inbound'
          ? 'inbound'
          : params.value === 'voice' && params.row.voiceDirection === 'outbound'
          ? 'outbound'
          : params.value;

      return renderIconForType(iconType);
    },
    hide: false,
  },
  {
    field: 'author',
    headerName: 'author'.toUpperCase(),
    flex: 1,
    hide: false,
  },
];
/**
 * CcfInteractionSearchMessagesTab - used to display Notes in contact card
 * @param props -? - CcfInteractionSearchMessagesTabProps
 * @example - <CcfInteractionSearchMessagesTab />
 */
export function CcfInteractionSearchMessagesTab(
  props: CcfInteractionSearchMessagesTabProps
) {
  const classes = useStyles();
  const [rowData, setRowData]: any = useState([]);
  const theme: Theme = useTheme();

  const isSmView = useMediaQuery(theme.breakpoints.down('xl'), { noSsr: true });
  const mobileViewColumns = [
    {
      field: 'caseId',
      headerName: 'caseId'.toUpperCase(),
      flex: 1,
      maxWidth: 190,
      sortable: false,
      hide: false,
    },
    {
      field: 'createdAt',
      headerName: 'created date'.toUpperCase(),
      flex: 1,
      maxWidth: 250,
      hide: false,
    },
    {
      field: 'status',
      headerName: 'read status'.toUpperCase(),
      flex: 1,
      maxWidth: 180,
      hide: false,
    },
  ];
  useEffect(() => {
    const rd = interactionSearchData.data.map((x, i) => {
      const icon = x.channelId.split('_')[0];
      return {
        id: i,
        caseId: x.id,
        channel: icon,
        author: x.author,
        createdAt:
          `${new Date(x.createdAt)}` !== 'Invalid Date'
            ? fomatToDateString(new Date(x.createdAt)) +
              ' ' +
              fomatToTimeString(new Date(x.createdAt))
            : '',
        status: x.status,
        customerName: `${x.authorEndUserIdentity.firstName} ${x.authorEndUserIdentity.lastName}`,
        voiceDirection: x.direction,
      };
    });
    setRowData(rd);
  }, []);

  return (
    <CcfBox
      id={`agent_interactionSearch_messages_tab_container`}
      style={{ height: '100%', width: '100%' }}
    >
      {' '}
      <CcfBox className={styles.tableBlock}>
        <CcfBox className={styles.tableHeader}>
          <CcfBox
            className={styles.searchBoxSection}
            sx={isSmView ? { width: '60%' } : { width: '80%' }}
          >
            <CcfBox className={styles.searchBox}>
              <CcfDeboucedInput
                id="agent_interactionSearch_messages_tab_searchContainer"
                size="small"
                style={{
                  background: 'white',
                }}
                className={classes.searchInput}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <Search htmlColor="grey" />
                    </InputAdornment>
                  ),
                }}
                placeholder="Search content"
                variant="outlined"
                fullWidth
                delay={1500}
              />
            </CcfBox>
          </CcfBox>

          <CcfBox
            id={`agent_interactionSearch_messages_tab_filtersContainer`}
            className={styles.filterIconBlock}
            sx={isSmView ? { width: '30%' } : { width: '8%' }}
          >
            <Button
              sx={{
                gap: '7px',
                padding: 0,
                width: '24px',
                height: '38px',
                minWidth: 'auto',
                '&.MuiButtonBase-root:hover': { bgcolor: 'transparent' },
              }}
              id="agent_interactionSearch_filters_popOver_button"
            >
              <CcfSupervisorFilterIcon style={{ fontSize: 14 }} />
              <CcfTypography className={styles.filtersHeader}>
                Filters
              </CcfTypography>
            </Button>
          </CcfBox>
          <CcfBox
            id={`agent_interactionSearch_messages_tab_customColumns`}
            className={
              !isSmView ? styles.columnIconBlock : styles.columnIconHideBlock
            }
          >
            <div style={{ height: '18px' }}>
              {isSmView ? (
                <CcfOverflowIcon />
              ) : (
                <CcfInteractionSearchColumnIcon />
              )}
            </div>
            {!isSmView && (
              <CcfTypography
                className={styles.filtersHeader}
                translationKey={'columns'}
              ></CcfTypography>
            )}
          </CcfBox>
          <CcfBox flexDirection="column" height="100%">
            {/* <CcfInteractionSearchCustomizableMenu /> */}
          </CcfBox>
        </CcfBox>
        <CcfBox style={{ height: '495px', overflowY: 'scroll' }}>
          <CcfBox
            style={{
              height: 'inherit',
              backgroundColor: '#FFFF',
              overflowY: 'hidden',
              borderTop: '1px solid #E1E1E1',
            }}
            id={`agent_interactionSearch_messages_tab_dataGridContainer`}
          >
            {' '}
            <DataGrid
              classes={{ root: classes.root }}
              rows={rowData}
              columns={isSmView ? mobileViewColumns : columns}
              rowHeight={40}
              // getRowId={(row) => row?.id}
              pageSize={10}
              headerHeight={40}
              // onSelectionModelChange={handleSelectionChange}
              // autoHeight
              pagination
              rowsPerPageOptions={[5, 10, 25]}
              getRowClassName={(params: any) => `styledrows`}
              sx={{
                '& .MuiDataGrid-columnHeaderTitle': {
                  color: '#3F5C69',
                  fontWeight: '600',
                  fontSize: '12px',
                  fontFamily: 'Open Sans',
                },
              }}
            />
          </CcfBox>
        </CcfBox>
      </CcfBox>
    </CcfBox>
  );
}

export default CcfInteractionSearchMessagesTab;
